import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { NoteBoilerplatesComponent } from './note-boilerplates.component';
import { NoteBoilerplatesCreateComponent } from './note-boilerplates-create/note-boilerplates-create.component';

const routes: Routes = [{
  path: '', component: NoteBoilerplatesComponent,
  children: [
    { path: '____createBoilerplate', component: NoteBoilerplatesCreateComponent }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NoteBoilerplatesRoutingModule { }
